var _defs, _circle, _circle2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew290({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.09,
    cy: 8,
    r: 0.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.91,
    cy: 8,
    r: 0.82
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "14.88 8 12.86 8 11.9 4.61 9.98 11.39 8.06 4.61 6.14 11.39 4.21 4.61 3.25 8 1.09 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew290);
export default __webpack_public_path__ + "static/media/Symbolpack_New_290.db7805c9ec3d3159c50a31bea808b1ac.svg";
export { ForwardRef as ReactComponent };